
export const imageDB = {

    scene1: require("../assets/onboarding/scene1.png"),
    scene2: require("../assets/onboarding/scene2.png"),
    scene3: require("../assets/onboarding/scene3.png"),
    splash: require("../assets/splash/splash.png"),
    car: require("../assets/home/car.png"),
    ranking: require("../assets/home/ranking.png"),
    education: require("../assets/home/education.png"),
    localservice: require("../assets/home/localservice.png"),
    shopping: require("../assets/home/shopping.png"),
    notice: require("../assets/home/notice.png"),
}

export const getImage = (key) => imageDB[key];
export const hasImage = (key) =>
    Object.prototype.hasOwnProperty.call(imageDB, key);
export const keys = () => Object.keys(imageDB);

// 선택: 초기 로딩 시 프리로드 하고 싶을 때 호출
export const preloadImages = () => {
    if (typeof window === "undefined") return;
    Object.values(imageDB).forEach((src) => {
        const img = new Image();
        img.src = src;
    });
};